import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface IBillingQuickStatsProps {
  organizationId: string;
}

export const BillingQuickStats: React.FC<IBillingQuickStatsProps> = ({ organizationId }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
      gap: 3,
    }}
  >
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 4 }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 0.5 }}
      >
        Org ID
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
        {organizationId}
      </Typography>
    </Paper>
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 4 }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 0.5 }}
      >
        Primary Admin
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
        Sarah Jenkins
      </Typography>
    </Paper>
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: 'success.main',
          boxShadow: '0 0 10px rgba(16, 185, 129, 0.5)',
        }}
      />
      <Box>
        <Typography
          variant="caption"
          sx={{ fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block' }}
        >
          Status
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 800, color: 'success.main', letterSpacing: '-0.01em' }}>
          Active
        </Typography>
      </Box>
    </Paper>
  </Box>
);
